module.exports = __webpack_public_path__ + "static/media/LUP_zast_L1.0d0532b8.svg";